<template>
  <div>
    <userprofile :user="user"></userprofile>
  </div>
</template>

<script>
import userProfile from '@/components/users/userProfile'
export default {
  name: 'profileWrapper',
  components: { userprofile: userProfile },
  data () {
    return {
      user: this.$root.$data.user
    }
  }
}
</script>



// WEBPACK FOOTER //
// profileWrapper.vue?2241ed06